// extracted by mini-css-extract-plugin
export default {"main":"oba-z"};